import { nanoid } from 'nanoid';
export function treeMap(data, callback, { depth = 0, parentId = '0', parentKey = '0', parentIds = [], parentKeys = [], } = {
    parentId: '0',
    depth: 0,
    parentKey: '0',
    parentIds: [],
    parentKeys: [],
}) {
    return data.map((item) => {
        const id = item.id;
        let key = item.key || item.component || item.pcPath || '/' + nanoid();
        if (!key.startsWith('/')) {
            key = '/' + key;
        }
        key = key.replace(/\/$/, '');
        // ;
        const newItem = {
            ...item,
            id,
            depth,
            parentIds,
            parentKeys,
            parentId,
            parentKey,
            isShow: item.isShow || true,
            isExt: item.isExt || 'N',
            name: item.name || item.title || '',
            path: key,
            key,
            component: item.component || key,
            iconPath: item.iconPath || item.icon,
            label: item.meta?.title,
            title: item.meta?.title,
            meta: item.meta || {
                icon: item.iconPath || '',
                title: item.name,
            },
        };
        if (item['children'] && item['children'].length > 0) {
            newItem.isLeaf = false;
            newItem['children'] = treeMap(item['children'], callback, {
                depth: depth + 1,
                parentIds: parentIds ? parentIds.concat(id) : [id],
                parentKeys: parentKeys ? parentKeys.concat(key) : [key],
                parentId: id,
                parentKey: key,
            });
        }
        else {
            newItem['children'] = undefined;
            newItem.isLeaf = true;
        }
        return callback(newItem);
    });
}
